import { ConsumerProfile } from '..'
import { supportsBiometricWithoutUserInteraction } from '../../utils/device'
import { ConsumerAddress, CreditFacilityStatus } from '@afterpaytouch/portal-api'
import { intlFormat, parseISO } from 'date-fns'
import { FacilityCohort, SupportedLocale } from '../../model'

export const verifyIfUserAuthenticatorIsAvailable = async (): Promise<boolean> => {
  try {
    const pkc = window?.PublicKeyCredential

    const platformAuthenticatorAvailable = (await pkc?.isUserVerifyingPlatformAuthenticatorAvailable()) ?? false

    const canPromptWithoutUserInteraction = supportsBiometricWithoutUserInteraction()

    return platformAuthenticatorAvailable && canPromptWithoutUserInteraction
  } catch (err) {
    console.warn(err)
    return false
  }
}

export const getConsumerName = (profile: ConsumerProfile | undefined): string => {
  if (typeof profile === 'undefined') {
    return ''
  }

  const profileGivenName = profile.givenNames ?? ''
  const profileSurname = profile.surname ?? ''
  const bothNamesExist = profileGivenName.length > 0 && profileSurname.length > 0

  return `${profileGivenName}${bothNamesExist ? ' ' : ''}${profileSurname}`
}

export const convertConsumerAddress = (address?: ConsumerAddress): string => {
  if (typeof address === 'undefined') {
    return ''
  }
  return `${address?.address1} ${address?.address2 ?? ''}, ${address?.suburb}, ${address?.state}, ${address?.postcode}`
}

export const convertConsumerDateOfBirth = ({ dateOfBirth, locale = 'en-AU' }: { dateOfBirth?: string; locale: SupportedLocale }): string => {
  if (typeof dateOfBirth === 'undefined') {
    return ''
  }
  const date = parseISO(dateOfBirth)

  return intlFormat(
    date,
    {
      month: '2-digit',
      year: 'numeric',
      day: '2-digit',
    },
    { locale }
  )
}

export const getFacilityCohortForNewUsers = (consumerFacility?: CreditFacilityStatus): FacilityCohort => {
  switch (consumerFacility) {
    case 'CLOSED':
      return FacilityCohort.LCCC_NEW_USER_FACILITY_CLOSED
    case 'NONE':
      return FacilityCohort.LCCC_NEW_USER_FACILITY_NONE
    case 'OPEN':
      return FacilityCohort.LCCC_NEW_USER_FACILITY_OPEN
    default:
      return FacilityCohort.LCCC_NEW_USER_FACILITY_UNKNOWN
  }
}

export const getFacilityCohortForExistingUsers = (consumerFacility?: CreditFacilityStatus): FacilityCohort => {
  switch (consumerFacility) {
    case 'CLOSED':
      return FacilityCohort.LCCC_EXISTING_USER_FACILITY_CLOSED
    case 'NONE':
      return FacilityCohort.LCCC_EXISTING_USER_FACILITY_NONE
    case 'OPEN':
      return FacilityCohort.LCCC_EXISTING_USER_FACILITY_OPEN
    default:
      return FacilityCohort.LCCC_EXISTING_USER_FACILITY_UNKNOWN
  }
}
